'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
var $ = require("jquery");
var _common_1 = require("./_common");
var _loading_1 = require("./_loading");
var _top_1 = require("./_top");
var _about_1 = require("./_about");
var _scroll_1 = require("./_scroll");
var _youtube_1 = require("./_youtube");
var _modal_1 = require("./_modal");
var _slick_1 = require("./_slick");
$(function () {
    new _common_1.default.aTag();
    new _loading_1.default.MyLoading();
    new _top_1.default.MyTop();
    new _about_1.default.MyAbout();
    new _scroll_1.default.Common();
    new _scroll_1.default.About();
    new _scroll_1.default.Project();
    // new Scroll.Ooh();
    // new Scroll.OohJr();
    // new Scroll.Cm();
    new _scroll_1.default.Gallery();
    new _youtube_1.default.MyYoutube();
    new _modal_1.default.MyModal();
    new _slick_1.default.MySlick();
});
